let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("91SIJ")]).then(() => parcelRequire('bmeQi'));